import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { emailTemplateQueryKeys } from "./emailTemplateQueryKeys";

export function useEmailTemplateEdit({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      emailTemplateId,
      patchedFields,
    }: {
      emailTemplateId: number;
      patchedFields: { [k: string]: any };
    }) => api.emailTemplateApi.update(emailTemplateId, patchedFields),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: emailTemplateQueryKeys.all() });
    },
  });
}
